<template>
  <PageWrapper :page-data="pageData"
               :brand="brandFromStore">
    <template #header-logo>
      <HeaderLogo />
    </template>
    <template #header-search>
      <HeaderSearch />
    </template>
    <template #header-user-navi>
      <HeaderUserNavi />
    </template>
    <template #cookbook-button-bar>
      <CookbookButtonBar />
    </template>
    <template #footer>
      <PageFooter :footer-data="pageData.footer" />
    </template>
  </PageWrapper>
</template>

<script>
import { mapState } from 'pinia'
import { defineAsyncComponent } from 'vue'

// these components will be injected into the app via slots
import PageWrapper from '../../components/PageWrapper.vue'
import { useDefaultAppInit, defaultAppInitProps } from '../../composables/use-default-app-init'
import PageFooter from './theme/Footer.vue'
import HeaderLogo from './theme/HeaderLogo.vue'
import HeaderSearch from './theme/HeaderSearch.vue'
import HeaderUserNavi from './theme/HeaderUserNavi.vue'
import { usePageStore } from '../../stores/page'

const CookbookButtonBar = defineAsyncComponent(() => import('./theme/Cookbook/ButtonBar.vue'))

export default {
  components: {
    CookbookButtonBar,
    HeaderLogo,
    HeaderSearch,
    HeaderUserNavi,
    PageFooter,
    PageWrapper
  },
  props: defaultAppInitProps,
  setup (props) {
    useDefaultAppInit(props)
  },
  computed: {
    ...mapState(usePageStore, ['pageData', 'brandFromStore'])
  }
}
</script>
